import { ThemeProvider } from "@material-ui/core/styles";
import moment from "moment";
import Moment from "moment-timezone";
import React, { useEffect, useState, useReducer } from "react";
import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import AccentsAndDialects from "../src/components/core/AccentsAndDialects/AccentsAndDialects";
import CultureCentreLocation from "./components/core/CultureCentreLocation/CultureCentreLocation";
import CultureNotesTopic from "../src/components/core/CultureNotesTopic/CultureNotesTopic";
import "./App.scss";
import CultureCentre from "./components/core/CultureCentre/CultureCentre";
import EmailTemplates from "./components/core/EmailTemplates/EmailTemplates";
import HomePage from "./components/core/HomePage/HomePage";
import MySchedulePage from "./components/core/MyScheduleComponentBlock/MySchedulePage";
import ProgressPage from "./components/core/ProgressPage/ProgressPage";
import ProductSessionsBlock from "./components/core/MyScheduleComponentBlock/ProductSessionsBlock";
import SessionReport from "./components/core/SessionReportBlock/SessionReport";
import FooterComponentBlock from "./components/shared/FooterComponent/FooterComponentBlock";
import Header from "./components/shared/Header/Header";
import MaintenancePage from "./components/shared/MaintenancePage/MaintenancePage";
import PageNotFound from "./components/shared/PageNotFoundPage/PageNotFound";
import RenewalIntercept from "./components/shared/Intercepts/RenewalIntercept/RenewalIntercept";
import CultureCenterIntercept from "./components/shared/Intercepts/CultureCenterIntercept/CultureCenterIntercept";
import { getCookieValue, setCookies } from "./cookieHelper";
import { useSelector, useDispatch } from "react-redux";
import INTLProvider from "./i18n/provider";
import translate from "./i18n/translate";
import theme from "./theme";
import { languageList } from "../src/i18n/locales";
import ReactGA from "react-ga";
import Toaster from "./components/shared/Toaster/Toaster";
import allActions from "./redux/actions";
import Logout from "./components/shared/Logout/Logout";
import LearnerProfile from "./components/shared/LearnerProfile/LearnerProfile";
import { allEnglishProductIds, soloProducts } from "./globalConstants";
import VideoPlayer from "./components/shared/VideoPlayer/VideoPlayer";
import Twt from "./components/core/Twt/Twt";
import VocabularyCenterPOC from "./components/core/VocabularyCenter-POC/index";
import { isEmailBitOn } from "./utils/FeatureBitCheck";
import SoundsOfEnglish from "./components/core/SoundsOfEnglish";
import SideNavBar from "./components/core/SoundsOfEnglish/SideNavBar";
import SoeTemplate from "./components/core/SoundsOfEnglish/SoeTemplate";
import WritingCenter from "./components/core/WritingCenter";
import GlobalCommunityTutorials from "./components/core/GlobalCommunityTutorials";
import IndustryFeed from "./components/core/IndustryFeed";
import ModalPopup from "./components/shared/ModalPopup/ModalPopup";
import { Button, Typography } from "@material-ui/core";
import DynamicIntercept from "./components/shared/DynamicIntercept/DynamicIntercept";
import { interceptData } from "./components/shared/DynamicIntercept/InterceptConstants";
import useBrowserStorage from "./components/shared/StoreLocalInfo";
import ProgressDetails from "./components/core/ProgressDetailsPage/ProgressDetails";
import { getActiveCourse } from "./components/core/MyScheduleComponentBlock/MySchedulePageUtils";

import {
  StressAndIntonation,
  StressAndIntonationTemplate,
  StressAndIntonationSideBar,
} from "./components/core/StressAndIntonation";
import WelcomeForm from "./components/core/WelcomeForm/WelcomeForm";
import VocabularyCenter from "./components/core/VocabularyCenter-POC/VocabularyCenter";
import TopicList from "./components/core/VocabularyCenter-POC/TopicList";
import TopicWordList from "./components/core/VocabularyCenter-POC/TopicWordList";
declare global {
  interface Window {
    Intercom: any;
  }
  interface Window {
    liveagent: any;
  }
  interface Window {
    intercomSettings: any;
  }
}
window.Intercom = window.Intercom || {};
window.intercomSettings = window.intercomSettings || {};
window.liveagent = window.liveagent || {};

const App = (props: any) => {
  const navigate = useNavigate();
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  let [currentuLang, setCurrentuLang] = useState("EN");
  let [languageSet, setLanguageSet] = useState(false);
  const GALocation = useLocation();
  const [maintenance] = useState(JSON.parse(process.env.REACT_APP_MAINTENANCE_COMPONENT ?? "[]") || []);
  const [duration] = useState(JSON.parse(process.env.REACT_APP_MAINTENANCE_DURATION ?? "[]") || []);
  const [isRenewal, setIsRenewal] = useState(false);
  const [cultureCenterIntercept, setCultureCenterIntercept] = useState(false);
  const [isEnglishUser, setIsEnglishUser] = useState(true);
  const [isOneUser, setIsOneUser] = useState<boolean | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [logoutWarningDialog, setLogoutWarningDialog] = useState(false);
  const [isInterceptEnabled, setIsInterceptEnabled] = useState(false);
  const [companyInterceptData, setCompanyInterceptData] = useState("");
  const [previousPath, setPreviousPath] = useState<any>({ path: window.location.pathname });
  const [interceptSession, setInterceptSession] = useBrowserStorage("learnersintercept", {
    isInterceptNotClosed: true,
  });
  const [activeCourseId, setActiveCourseId] = useState(null);
  const signoutTime = 1800000;
  const warningTime = 1500000;
  let warnTimeout: any;
  let logoutTimeout: any;

  const warn = () => {
    setLogoutWarningDialog(true);
  };

  const logout = () => {
    setLogoutWarningDialog(false);
    navigate("/logout");
  };

  const setTimeouts = () => {
    warnTimeout = setTimeout(warn, warningTime);
    logoutTimeout = setTimeout(logout, signoutTime);
  };

  const clearTimeouts = () => {
    if (warnTimeout) clearTimeout(warnTimeout);
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  if (!getCookieValue("ulang") || getCookieValue("ulang") === "en") {
    setCookies(`ulang`, "EN");
  } else {
    if (!languageSet) {
      setLanguageSet(true);
    }
  }

  const isNewsfeedTimezoneBlocked = async () => {
    const blockedCountryList = ["CN"];
    const blockedTzList = [
      "Asia/Zhejiang",
      "Asia/Yunnan",
      "Asia/Xinjiang",
      "Asia/Tibet",
      "Asia/Tianjin",
      "Asia/Sichuan",
      "Asia/Shanxi",
      "Asia/Shanghai",
      "Asia/Shandong",
      "Asia/Shaanxi",
      "Asia/Qinghai",
      "Asia/Ningxia Hui Autonomous Region",
      "Asia/Liaoning",
      "Asia/Jilin",
      "Asia/Jiangxi",
      "Asia/Jiangsu",
      "Asia/Inner Mongolia",
      "Asia/Hunan",
      "Asia/Hubei",
      "Asia/Henan",
      "Asia/Heilongjiang",
      "Asia/Hebei",
      "Asia/Hainan",
      "Asia/Guizhou",
      "Asia/Guangxi",
      "Asia/Guangdong",
      "Asia/Gansu",
      "Asia/Fujian",
      "Asia/Chongqing",
      "Asia/Beijing",
      "Asia/Anhui",
    ];
    dispatch(
      allActions.commonActions.setIsNewsfeedTzBlocked(
        allInfo.peopleInformation.data.getpeopleInformation.country.includes(blockedCountryList) ||
          blockedTzList.includes(Moment.tz.guess(true)),
      ),
    );
  };

  const afterGetLearnerInfo = (resp: any) => {
    isNewsfeedTimezoneBlocked();
  };

  const onUnload = (e: any) => {
    if (!allInfo.common.isLoading) {
      if (!allInfo.common.isUserAuthenticated) {
        e.preventDefault();
        if (window.location.href !== `${window.location.origin}/`) {
          if (window.location.href.search(/redirectUrl/gi) === -1) {
            sessionStorage.setItem("rURL", window.location.pathname);
            sessionStorage.setItem(
              "rURLf",
              `${window.location.origin}/?redirectUrl=${encodeURIComponent(window.location.origin)}${encodeURIComponent(
                sessionStorage.getItem("rURL") ?? "",
              )}`,
            );
          }
        } else {
          sessionStorage.removeItem("rURL");
          sessionStorage.removeItem("rURLf");
          sessionStorage.removeItem("courseId");
        }
      }
    }
  };

  const getTOSSession = (userId: string, eventTypeId: string) => {
    dispatch(allActions.tosSessionInfoAction.getTosSessionInfo(userId, eventTypeId));
  };

  const getRenewalData = (userId: number) => {
    if (!allInfo.renewalInformation.data) {
      dispatch(allActions.renewalInformationAction.getStoreRenewalInfo(userId));
    }
  };
  async function checkForRenewal(pinfo: any, renewalInfo: any) {
    const isRenwalFeatureBitOn: any = isEmailBitOn(
      allInfo.peopleInformation.data.getpeopleInformation,
      "Renewal Email/Reminders/Intercept",
    );
    if (isRenwalFeatureBitOn) {
      for (let i: number = 0; i < pinfo.license.length; i++) {
        if (
          (pinfo.license[i].endDate - Moment().unix()) / 3600 <= 720 &&
          sessionStorage.getItem("RenwalIntercept") !== "skip"
        ) {
          let latestDate: any;
          if (renewalInfo.getRenewalDate) {
            const dataExtract = JSON.parse(renewalInfo.getRenewalDate);
            const renewDataArray = dataExtract.renewEmails;
            latestDate = renewDataArray
              .map(function (e: any) {
                return e.RenewDate;
              })
              .sort()
              .reverse()[0];
          }
          if (!latestDate || (Moment().unix() - new Date(latestDate).getTime() / 1000) / 3600 > 720) {
            sessionStorage.setItem("RenwalIntercept", "true");
            setIsRenewal(true);
            if (!allInfo.isLoading && !allInfo.common.isLoading) {
              dispatch(allActions.commonActions.setRenewalInterceptRequired(true));
            }
            sessionStorage.setItem("RenewalEndDate", pinfo.license[i].endDate);
          } else {
            setIsRenewal(false);
            if (!allInfo.isLoading && !allInfo.common.isLoading) {
              dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
            }
            sessionStorage.setItem("RenwalIntercept", "false");
          }
        } else {
          if (!allInfo.isLoading && !allInfo.commonActions && !allInfo.common.isLoading) {
            dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
          }
        }
      }
    } else {
      dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
    }
  }

  useEffect(() => {
    setPreviousPath(GALocation.pathname);
    if (!GALocation.pathname.match(/^\/vocabularycenter.*/)) {
      // Remove the item from sessionStorage
      sessionStorage.removeItem("isVocabCenter");
    }
  }, [GALocation.pathname]);

  const timeOnSightForEventListeners = () => {
    const uId: any = sessionStorage.getItem("leuId")?.toString();
    if (window.location.pathname !== previousPath.path) {
      getTOSSession(uId, "2");
      setPreviousPath((prevPath: any) => {
        return { ...prevPath, path: window.location.pathname };
      });
    }
  };

  useEffect(() => {
    const events = ["click"];

    for (let i in events) {
      window.addEventListener(events[i], timeOnSightForEventListeners);
    }
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], timeOnSightForEventListeners);
        clearTimeouts();
      }
    };
  }, [window.location.pathname, GALocation, previousPath]);

  useEffect(() => {
    const events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress", "touchstart", "touchmove"];

    const resetTimeout = () => {
      clearTimeouts();
      setTimeouts();
    };

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }

    setTimeouts();
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      }
    };
  }, []);

  useEffect(() => {
    if (!allInfo.renewalInformation.isLoading) {
      if (allInfo.renewalInformation.data && allInfo.peopleInformation.data) {
        checkForRenewal(allInfo.peopleInformation.data.getpeopleInformation, allInfo.renewalInformation.data);
      }
    }
    if (
      allInfo.peopleInformation &&
      allInfo.peopleInformation.data &&
      allInfo.peopleInformation.data.getpeopleInformation &&
      allInfo.peopleInformation.data.getpeopleInformation &&
      process.env.REACT_APP_ENVIRONMENT !== "prod"
    ) {
      const license = allInfo.peopleInformation.data.getpeopleInformation.license;
      if (typeof license === "object" && license.length > 0) {
        const isProductOne = license.findIndex((eachObject: any) => eachObject.productId === "1");
        if (isProductOne !== -1) {
          setIsOneUser(true);
        } else {
          setIsOneUser(false);
        }
      }
    } else if (process.env.REACT_APP_ENVIRONMENT === "prod") {
      setIsOneUser(false);
    }
  }, [allInfo]);

  useEffect(() => {
    triggerGlobalToaster();
  }, [allInfo.toaster.showToast]);

  useEffect(() => {
    updatePageTitle();
    window.scrollTo(0, 0);
    if (allInfo.jwkPublicKey && allInfo.jwkPublicKey.data) {
      props.jwtValidation(getCookieValue(`${process.env.REACT_APP_ENV}IdToken`), allInfo.jwkPublicKey.data.keys[0]);
    }
  }, [window.location.href]);

  useEffect(() => {
    if (
      !allInfo.common.isLoading &&
      !allInfo.peopleInformation.isLoading &&
      !allInfo.learnerTasks.isLoading &&
      !allInfo.jwkPublicKey.isLoading &&
      !allInfo.renewalInformation.isLoading
    ) {
      if (!allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
        afterGetLearnerInfo(allInfo.peopleInformation);
        if (!allInfo.renewalInformation.isFailed) {
          getRenewalData(Number(allInfo.common.leuId));
        } else {
          dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
        }
      }
    }
  }, [
    allInfo.common,
    allInfo.peopleInformation,
    allInfo.learnerTasks,
    allInfo.jwkPublicKey,
    allInfo.renewalInformation,
    allInfo.common.isRenewalInterceptRequired,
  ]);

  useEffect(() => {
    const orgId = allInfo?.peopleInformation?.data?.getpeopleInformation?.orgId.toString();
    if (orgId) {
      const dataForIntercept: any = interceptData.find((data: any) => {
        let orgInterceptId = data.id.split("|").find((oId: any) => oId == orgId);
        if (orgInterceptId === orgId) return data;
      });
      const isWithinInterval = dataForIntercept && getInterceptTime(process.env[dataForIntercept.intercept_duration]);
      if (dataForIntercept && isWithinInterval) {
        setCompanyInterceptData(dataForIntercept);
        if (interceptSession?.isInterceptNotClosed) {
          setIsInterceptEnabled(true);
          navigate("/intercept");
        }
      }
    }
  }, [allInfo.peopleInformation.data?.getpeopleInformation?.accountId]);

  useEffect(() => {
    if (!allInfo.common.isLoading && !allInfo.peopleInformation.isLoading && allInfo.peopleInformation.data) {
      if (
        isEnglishUser &&
        (allInfo.common.managerEmail || !allInfo.common.isManagerEmailRequired) &&
        allInfo.common.isRenewalInterceptRequired === false
      ) {
        if (
          allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28) === "1"
        ) {
          let isWithinInterval = getInterceptTime(process.env.REACT_APP_CULTURE_CENTER_INTERCEPT);
          setCultureCenterIntercept(isWithinInterval);
          if (localStorage.getItem("cultureCenterSelected") !== "true" && isWithinInterval) {
            navigate("/culturecenterintercept");
          }
        } else {
          setCultureCenterIntercept(false);
        }
      }
    }
  }, [allInfo.common.managerEmail, allInfo.common.isRenewalInterceptRequired, allInfo.peopleInformation]);

  useEffect(() => {
    if (!allInfo.common.isLoading && !allInfo.peopleInformation.isLoading && allInfo.peopleInformation.data) {
      isEnglishFeatureRequired(allInfo.peopleInformation.data.getpeopleInformation.license);
    }
  }, [allInfo.peopleInformation]);

  const getInterceptTime = (endDate: any) => {
    let duration = JSON.parse(endDate || "[]");

    if (duration.length > 0) {
      if (
        moment.utc(duration[0].split("/")[0], "YYYY-MM-DD HH:mm").unix() <= Moment().unix() &&
        moment.utc(duration[0].split("/")[1], "YYYY-MM-DD HH:mm").unix() >= Moment().unix()
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    setCurrentuLang(getCookieValue("ulang") || "EN");
    const selectedLang = getCookieValue("ulang") || "EN";
    languageList.forEach((language: any) => {
      if (language.locale === selectedLang) {
        language.isSelected = true;
      } else if (language.isSelected) {
        language.isSelected = false;
      }
    });
  }, [languageSet]);

  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", open);
    if (!open) {
      handleAfterToastClose();
    }
  };

  const updatePageTitle = () => {
    let currentFullPath: string = "";
    if (window.location.href.search(/redirectUrl/gi) === -1) {
      currentFullPath = window.location.pathname;
      if (currentFullPath.length === 1 && currentFullPath === "/") {
        if (!allInfo.common.isLoading) {
          if (allInfo.common.isUserAuthenticated) {
            document.title = "Halo - Home";
          } else {
            document.title = "Halo";
          }
        }
      }
      if (currentFullPath.indexOf("/welcome") >= 0) {
        document.title = "Halo - Welcome";
      }
      if (currentFullPath.indexOf("/profile") >= 0) {
        document.title = "Halo - Profile";
      }
      if (currentFullPath.indexOf("/progress") >= 0) {
        document.title = "Halo - Progress";
      }
      if (currentFullPath.indexOf("/schedule") >= 0) {
        document.title = "Halo - Schedule";
      }
      if (currentFullPath.indexOf("/culturecenter") >= 0) {
        document.title = "Halo - Culture Center";
      }
      if (currentFullPath.indexOf("/emailtemplates") >= 0) {
        document.title = "Halo - Email Templates";
      }
      if (currentFullPath.indexOf("/twt") >= 0) {
        document.title = "Halo - Talk with Teacher";
      }
      if (currentFullPath.indexOf("/accentsanddialects") >= 0) {
        document.title = "Halo - Accents and Dialects";
      }
      if (currentFullPath.indexOf("/maintenance") >= 0) {
        document.title = "Halo - Maintenance";
      }
      if (currentFullPath.indexOf("/renewalintercept") >= 0) {
        document.title = "Halo - Renewal Intercept";
      }
      if (currentFullPath.indexOf("/culturecenterintercept") >= 0) {
        document.title = "Halo - Culture Center Intercept";
      }
      if (currentFullPath.indexOf("/vocabularycenter") >= 0) {
        document.title = "Halo - Vocabulary Center";
      }
      if (currentFullPath.indexOf("/stressandintonation") >= 0) {
        document.title = "Halo - Stress and Intonation";
      }
      if (currentFullPath.indexOf("/soundsofenglish") >= 0) {
        document.title = "Halo - Sounds of English";
      }
      if (currentFullPath.indexOf("/writingcenter") >= 0) {
        document.title = "Halo - Writing Center";
      }
      if (currentFullPath.indexOf("/globalcommunitytutorials") >= 0) {
        document.title = "Halo - Global Community Tutorials";
      }
      if (currentFullPath.indexOf("/industryfeed") >= 0) {
        document.title = "Halo - Industry Feed";
      }
      if (currentFullPath.indexOf("/learnersintercept") >= 0) {
        document.title = "Halo - SSO Learners Intercept";
      }
    } else {
      document.title = "Halo";
    }
  };

  const performOnEveryPage = () => {
    if (
      !allInfo.announcements.data &&
      allInfo.common.leuId &&
      !allInfo.announcements.isLoading &&
      !allInfo.announcements.isFailed
    ) {
      dispatch(allActions.announcementsAction.getAnnouncements(allInfo.common.leuId));
    }
    updatePageTitle();
    let isAuthenticatedNow = false;
    if (!allInfo.common.isLoading) {
      if (allInfo.common.isUserAuthenticated) {
        isAuthenticatedNow = true;
        profileIncompletionRedirection();
      }

      if (
        window.location.pathname !== "/welcome" &&
        !allInfo.common.isLoading &&
        allInfo.common.isManagerEmailRequired === true &&
        !allInfo.common.managerEmail
      ) {
        sessionStorage.setItem("urlRedirect", window.location.pathname);
        return <HomePage authProps={{ ...props }} isEnglishUser={isEnglishUser} />;
      } else if (window.location.pathname !== "/welcome") {
        if (!allInfo.common.isLoading && allInfo.peopleInformation.data) {
          dispatch(
            allActions.commonActions.setManagerEmail(allInfo.peopleInformation.data.getpeopleInformation.managerEmail),
          );
          const isManagerEmailRequired: any = isEmailBitOn(
            allInfo.peopleInformation.data.getpeopleInformation,
            "Manager",
          );
          dispatch(allActions.commonActions.setManagerEmailRequired(isManagerEmailRequired));
        }
        profileIncompletionRedirection();
      } else if (window.location.pathname === "/welcome") {
        dispatch(allActions.commonActions.setManagerEmailRequired(false));
        sessionStorage.setItem("skipManagerEmail", "true");
      }
    }
    return isAuthenticatedNow;
  };

  const initGoogleAnalytics = (resp: any) => {
    if (resp.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85) === "1") {
      if (window.location.pathname === "/") {
        const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
        ReactGA.initialize(trackingId);
        const url = window.location.pathname + "home";
        ReactGA.set({ page: url });
        ReactGA.pageview(url);
      } else {
        const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
        ReactGA.initialize(trackingId);
        const url = window.location.pathname;
        ReactGA.set({ page: url });
        ReactGA.pageview(url);
      }
    }
  };

  useEffect(() => {
    if (!allInfo.peopleInformation.isLoading && !allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
      initGoogleAnalytics(allInfo.peopleInformation);
    }
  }, [GALocation]);

  useEffect(() => {
    let peopleCallDataInformation = allInfo.peopleInformation.data;
    if (peopleCallDataInformation && peopleCallDataInformation.getpeopleInformation) {
      let adminCheck = peopleCallDataInformation.getpeopleInformation.license.filter((pId: any) => {
        return pId.productId === "13";
      }).length;
      if (adminCheck > 0) {
        setIsAdmin(true);
      }
    }
  }, [allInfo.peopleInformation.data]);

  useEffect(() => {
    if (allInfo?.peopleInformation?.data?.getpeopleInformation) {
      setProduct(allInfo.peopleInformation.data.getpeopleInformation.license);
    }
  }, [allInfo.common, allInfo.peopleInformation]);

  useEffect(() => {
    if (allInfo.common.productID && !soloProducts.includes(allInfo.common.productID)) {
      if (!allInfo.tmsCourses.isLoading && !allInfo.tmsCourses.data) {
        const uuId = allInfo.common.luuId;
        dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
      }
    }
  }, [allInfo.peopleInformation, allInfo.common]);

  useEffect(() => {
    if (allInfo.tmsCourses.data) {
      let activeCourseData: any = getActiveCourse(allInfo.tmsCourses.data.getTMSGetCourse);
      setActiveCourseId(activeCourseData.courseId);
    }
  }, [allInfo.tmsCourses]);

  const shouldRedirectToProfile = (calledFromSlash?: boolean) => {
    let isAuthed = false;
    if (allInfo.learnerTasks) {
      if (allInfo.learnerTasks.data) {
        isAuthed = true;
        let filteredResp = [],
          respData = [];
        const resp = allInfo.learnerTasks;
        respData = resp.data.getLearnerTasks ? resp.data.getLearnerTasks : [];
        if (respData.length > 0) {
          filteredResp = respData.filter((taskObj: any) => {
            return `${taskObj.taskid}` === "1";
          });
        }
        if (isAdmin ? isAdmin : filteredResp && filteredResp.length > 0 && filteredResp[0].status) {
          sessionStorage.setItem("pComp", "true");
          sessionStorage.setItem("skipManagerEmail", "false");
        } else {
          sessionStorage.setItem("skipManagerEmail", "true");
          sessionStorage.removeItem("pComp");
          if (isAuthed) {
            if (window.location.pathname !== "/welcome") {
              navigate("/welcome");
            }
          }
        }
      } else {
        if (allInfo.learnerTasks.isFailed) {
          sessionStorage.removeItem("redDone");
          sessionStorage.removeItem("pComp");
        }
      }
    }
  };

  const profileIncompletionRedirection = () => {
    if (allInfo.learnerTasks && !allInfo.learnerTasks.isLoading) {
      if (allInfo.learnerTasks.data) {
        let redDone = sessionStorage.getItem("redDone") || null;
        let pComp = sessionStorage.getItem("pComp") || null;
        if (!redDone) {
          let filteredResp = [],
            respData = [];
          const resp = allInfo.learnerTasks;
          respData = resp.data.getLearnerTasks ? resp.data.getLearnerTasks : [];
          if (respData.length > 0) {
            filteredResp = respData.filter((taskObj: any) => {
              return `${taskObj.taskid}` === "1";
            });
          }
          sessionStorage.removeItem("redDone");
          if (isAdmin ? isAdmin : filteredResp && filteredResp.length > 0 && filteredResp[0].status) {
            sessionStorage.setItem("pComp", "true");
            if (window.location.pathname === "/welcome") {
              if (
                !allInfo.learnerTasks.isLoading &&
                allInfo.learnerTasks.data &&
                !allInfo.peopleInformation.isLoading &&
                allInfo.peopleInformation.data
              ) {
                navigate("/");
              }
            }
          } else {
            sessionStorage.removeItem("pComp");
            if (window.location.pathname !== "/welcome") {
              navigate("/welcome");
            }
          }
          shouldRedirectToProfile();
        } else {
          if (pComp) {
            if (window.location.pathname === "/welcome") {
              navigate("/");
            }
          }
          if (window.location.pathname !== "/welcome") {
            if (!pComp) {
              navigate("/welcome");
            }
          }
        }
      } else {
        if (allInfo.learnerTasks.isFailed) {
          sessionStorage.removeItem("redDone");
          sessionStorage.removeItem("pComp");
          shouldRedirectToProfile();
        }
      }
    }
  };

  const languageChange = async (lang?: string) => {
    if (lang) {
      setCookies(`ulang`, `${lang}`);
      setCurrentuLang(lang);
      dispatch(allActions.commonActions.setLanguage(lang));
      languageList.forEach((language: any) => {
        if (language.locale === lang) {
          language.isSelected = true;
        } else if (language.isSelected) {
          language.isSelected = false;
        }
      });
    }
  };

  const triggerGlobalToaster = () => {
    if (allInfo.toaster.showToast) {
      toasterHandle(allInfo.toaster.showToast, allInfo.toaster.toastSeverity, allInfo.toaster.toastTransMessage);
    }
  };

  const handleAfterToastClose = async () => {
    dispatch(allActions.toasterActions.resetToastMessage(false, "error", "message_errorDefault"));
  };

  const redirectHandle = () => {
    if (window.location.href !== `${window.location.origin}/`) {
      if (window.location.href.search(/redirectUrl/gi) === -1 && window.location.href.search(/logout/gi) === -1) {
        window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}/?redirectUrl=${encodeURIComponent(
          window.location.href,
        )}`;
      }
    } else {
      window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`;
    }
  };

  const shouldRedirectToSlash = () => {
    if (!allInfo.common.isLoading) {
      if (window.location.href !== `${window.location.origin}/`) {
        if (!allInfo.common.isLoading) {
          if (!props.isAuthenticating && !allInfo.common.isUserAuthenticated) {
            sessionStorage.setItem("apRedURL", window.location.pathname);
            redirectHandle();
          }
        }
      } else {
        if (!allInfo.common.isLoading) {
          if (!props.isAuthenticating && !allInfo.common.isUserAuthenticated) {
            redirectHandle();
            return <Navigate to="" />;
          }
        }
      }
    }
  };

  const isEnglishFeatureRequired = (license: any) => {
    setIsEnglishUser(license.some((licenseList: any) => allEnglishProductIds.indexOf(licenseList.productId) >= 0));
  };

  const homePageRedirection = () => {
    shouldRedirectToProfile(true);
    return <HomePage authProps={{ ...props }} isEnglishUser={isEnglishUser} />;
  };

  const redirectRoute = (component: any) => {
    return performOnEveryPage() ? component : shouldRedirectToSlash();
  };

  const setProduct = (licenses: any) => {
    if (licenses.length > 0 && !sessionStorage.getItem("isDemoUser")) {
      const filteredLicenses = filterSprintLevelLicenses(licenses);
      if (filteredLicenses.length > 0) {
        dispatch(allActions.commonActions.setProductID(filteredLicenses[0].productId));
      }
    }
  };

  const filterSprintLevelLicenses = (licenses: any) => {
    return licenses.filter((prod: { productId: string }) =>
      [
        "5",
        "6",
        "1",
        "13",
        "16",
        "19",
        "17",
        "18",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
      ].includes(prod.productId),
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <INTLProvider locale={currentuLang}>
        {logoutWarningDialog && (
          <ModalPopup
            toggleOpen={logoutWarningDialog}
            setOpen={setLogoutWarningDialog}
            classNameProps="logout-dialog-popup"
            body={
              <div className="logout-dialog-container">
                <div className="logout-dialog-title">
                  <Typography variant="h5">{translate("session_expiring")}</Typography>
                </div>
                <div className="logout-info-container">
                  <div>
                    <Typography variant="subtitle1">{translate("timer_title_1")}</Typography>
                    <Typography variant="subtitle1">{translate("timer_title_2")}</Typography>
                  </div>
                </div>
                <div className="logout-btn-container">
                  <Button
                    className="logout-btn"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setLogoutWarningDialog(false);
                    }}
                  >
                    {translate("ok_timer")}
                  </Button>
                </div>
              </div>
            }
          />
        )}
        <div className="App">
          {window.location.pathname !== "/virtualclassroom" && (
            <Header
              lChange={languageChange}
              currentLang={currentuLang}
              authProps={{ ...props }}
              isRenewal={isRenewal}
              setIsRenewal={setIsRenewal}
              cultureCenterIntercept={cultureCenterIntercept}
              isEnglishUser={isEnglishUser}
              isInterceptEnabled={isInterceptEnabled}
              activeCourseId={activeCourseId}
            />
          )}
          <Toaster
            open={toastOptions.toastOpen}
            severity={toastOptions.toastSeverity}
            toasterClosed={toasterHandle}
            messageKey={toastOptions.toastMessageKey}
          />
          <Routes>
            {maintenance.length > 0 &&
              maintenance[0] !== "" &&
              maintenance.map((path: any, key: number) => {
                return (
                  (duration[key] === "" ||
                    (moment.utc(duration[key].split("/")[0], "YYYY-MM-DD HH:mm").unix() <= Moment().unix() &&
                      moment.utc(duration[key].split("/")[1], "YYYY-MM-DD HH:mm").unix() >= Moment().unix())) && (
                    <Route
                      path={"/" + path}
                      element={redirectRoute(
                        <MaintenancePage
                          maintenanceMins={
                            duration[key] === ""
                              ? ""
                              : (moment.utc(duration[key].split("/")[1], "YYYY-MM-DD HH:mm").unix() - Moment().unix()) /
                                60
                          }
                        />,
                      )}
                    />
                  )
                );
              })}
            <Route path="/home" element={<HomePage authProps={{ ...props }} isEnglishUser={isEnglishUser} />} />
            <Route path="/logout" element={<Logout authProps={{ ...props }} />} />
            <Route path="/schedule" element={redirectRoute(<MySchedulePage />)} />
            <Route path="/schedule/:courseid" element={redirectRoute(<ProductSessionsBlock />)} />
            <Route path="/progress" element={redirectRoute(<ProgressPage />)} />
            <Route path="/progress/:paramProdID" element={redirectRoute(<ProgressPage />)} />
            <Route path="/sessionreport/:sessionid" element={redirectRoute(<SessionReport />)} />
            <Route path="/profile" element={redirectRoute(<WelcomeForm />)} />
            <Route path="/welcome" element={redirectRoute(<LearnerProfile />)} />
            <Route path="/welcome-new-form" element={redirectRoute(<WelcomeForm />)} />
            <Route path="/old-profile" element={redirectRoute(<LearnerProfile />)} />

            <Route path="/maintenance" element={redirectRoute(<MaintenancePage />)} />
            <Route path="/renewalintercept" element={redirectRoute(<RenewalIntercept />)} />
            {cultureCenterIntercept && (
              <Route path="/culturecenterintercept" element={redirectRoute(<CultureCenterIntercept />)} />
            )}
            {sessionStorage.getItem("isDemoUser") && (
              <Route
                path="/virtualclassroom"
                element={redirectRoute(
                  <div className="PageContainerBlock">
                    <VideoPlayer
                      source={"../videos/virtualclassroom.mp4"}
                      isplaying={true}
                      width={"100%"}
                      height={"100%"}
                      controls={true}
                    ></VideoPlayer>{" "}
                  </div>,
                )}
              />
            )}
            <Route path="/" element={homePageRedirection()} />

            <Route path="/accentsanddialects" element={redirectRoute(<AccentsAndDialects />)} />
            <Route path="/culturecenter" element={redirectRoute(<CultureCentre />)} />
            <Route path="/culturecenter/topic" element={redirectRoute(<CultureNotesTopic />)} />
            <Route path="/culturecenter/:country" element={redirectRoute(<CultureCentreLocation />)} />
            <Route path="/emailtemplates" element={redirectRoute(<EmailTemplates />)} />
            <Route path="/twt" element={redirectRoute(<Twt />)} />
            <Route
              path="/intercept"
              element={redirectRoute(
                <DynamicIntercept
                  companyInterceptData={companyInterceptData}
                  setInterceptFalse={() => {
                    setInterceptSession((learnerInterceptValue: any) => {
                      return { ...learnerInterceptValue, isInterceptNotClosed: false };
                    });
                    setIsInterceptEnabled(false);
                  }}
                />,
              )}
            />
            <Route path="/vocabularycenter" element={redirectRoute(<VocabularyCenter />)} />
            <Route path="/vocabularycenter/:topic" element={redirectRoute(<TopicList />)} />
            <Route path="/vocabularycenter/:topic/:subTopic" element={redirectRoute(<TopicWordList />)} />

            <Route path="/vc" element={redirectRoute(<VocabularyCenterPOC />)} />
            <Route path="/stressandintonation" element={redirectRoute(<StressAndIntonation />)} />
            <Route
              path="/stressandintonation/:activityId/:categoryId/"
              element={redirectRoute(<StressAndIntonationSideBar />)}
            >
              <Route path=":template/:templateID" element={redirectRoute(<StressAndIntonationTemplate />)} />
            </Route>
            <Route path="/soundsofenglish" element={redirectRoute(<SoundsOfEnglish />)} />
            <Route path="/writingcenter" element={redirectRoute(<WritingCenter />)} />
            <Route path="/globalcommunitytutorials" element={redirectRoute(<GlobalCommunityTutorials />)} />
            <Route path="/industryfeed" element={redirectRoute(<IndustryFeed />)} />
            <Route path="/progressDetails" element={redirectRoute(<ProgressDetails />)} />
            <Route path="/soundsofenglish/:activityId/" element={redirectRoute(<SideNavBar />)}>
              <Route path="/soundsofenglish/:activityId/" element={redirectRoute(<SoeTemplate />)} />
              <Route path=":template/:templateID" element={redirectRoute(<SoeTemplate />)} />
            </Route>
            <Route path="*" element={redirectRoute(<PageNotFound />)} />
          </Routes>
          {window.location.pathname !== "/virtualclassroom" && <FooterComponentBlock />}
        </div>
      </INTLProvider>
    </ThemeProvider>
  );
};

export default App;
